import React, { useId } from 'react'
import { T } from '@transifex/react'
import { FulfilmentType } from '../../../../models/fulfilment'

export interface FulfilmentSelectProps {
  title?: string
  onTypeChange: (type: FulfilmentType) => void
  defaultType?: string
  showUnspecified?: boolean
  message?: string
  disabled?: boolean
  stretched?: boolean
  outOfStockMessage?: string
  name?: string
}

const fulfilmentOptions = [
  {
    label: <T _str="None" _context="Fulfilment select" />,
    trackId: 'unspecified-fulfilment',
    type: FulfilmentType.UNSPECIFIED,
  },
  {
    label: <T _str="Delivery" _context="Fulfilment select" />,
    trackId: 'delivery-fulfilment',
    type: FulfilmentType.DELIVERY,
  },
  {
    label: <T _str="Pickup" _context="Fulfilment select" />,
    trackId: 'pickup-fulfilment',
    type: FulfilmentType.PICKUP,
  },
]

export const useFulfilmentSelectModel = ({
  defaultType,
  disabled,
  name,
  onTypeChange,
  showUnspecified,
}: FulfilmentSelectProps) => {
  const fallbackFulfilmentTypeName = `fulfilType-${useId()}`
  const fulfilmentTypeName = name || fallbackFulfilmentTypeName
  const options = showUnspecified
    ? fulfilmentOptions
    : fulfilmentOptions.filter(
        option => option.type !== FulfilmentType.UNSPECIFIED
      )

  return {
    fulfilmentTypeName,
    getIsDisabled: (type: FulfilmentType) => defaultType !== type && disabled,
    handleChange: (value: string | undefined) => {
      if (value) {
        onTypeChange(value as FulfilmentType)
      }
    },
    options,
  }
}
